import React from 'react'

function BannerPlaceholder () {
  return <div className="banner-placeholder" />
}

export default React.memo(BannerPlaceholder)
